<template>
  <v-app id="login-user-ui">
    <v-content login>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>

            <v-flex xs12>
              <div class="text-xs-center">
                <v-img fill-height v-if="this.img_folder"
                       :src="require('@/assets/clients/'+img_folder+'/logo.png')"
                       class="my-5 login-logo"
                       contain
                       height="120"
                ></v-img>
              </div>
            </v-flex>

            <v-spacer class="my-2"></v-spacer>

            <!-- Event Handling - Event Modifiers
            It is a very common need to call event.preventDefault(),
            therefore Vue provides event modifiers for v-on. Recall that modifiers are directive postfixes denoted by a dot. -->
            <!--mask="###-#########"-->
            <v-form v-on:submit.prevent="submit" ref="form" v-model="valid" lazy-validation>

              <!--@modified ana.castro 2019.08.16 SABO-1056-->
              <v-flex xs12 v-if="this.loginProviderFacebook">
                <div class="text-xs-center">
                  <FBLoginButton></FBLoginButton>
                  <!--                                    <FBLoginButton :params="fbSignInParams"></FBLoginButton>-->
                </div>
              </v-flex>
              <v-spacer class="my-2"></v-spacer>

              <!--@modified ana.castro 2019.08.27 SABO-1056-->
              <v-flex xs12 v-if="this.loginProviderGoogle">
                <div class="text-xs-center">
                  <GOOGLELoginButton></GOOGLELoginButton>
                </div>
              </v-flex>
              <v-spacer class="my-2"></v-spacer>

              <!--@modified ana.castro 2019.08.22 SABO-1056-->
              <v-flex xs12 v-if="this.loginProviderInstagram">
                <div class="text-xs-center">
                  <IGLoginButton></IGLoginButton>
                </div>
              </v-flex>

              <v-spacer class="my-4"></v-spacer>

              <div class="login-title1">
                <v-spacer class="my-2 login-title1-spacer"></v-spacer>

                <v-flex xs12>
                  <h2>{{ $vuetify.t('$vuetify.authentication.login_step_user_title') }}</h2>
                </v-flex>
              </div>

              <div class="login-title2">
                <v-spacer class="my-2 login-title2-spacer"></v-spacer>

                <v-flex xs12>
                  <h4>{{ $vuetify.t('$vuetify.authentication.login_step_user_subtitle') }}</h4>
                </v-flex>
              </div>

              <v-spacer class="my-2 login-user-spacer"></v-spacer>

              <v-flex xs12>
                <!-- @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number -->
                <!--                                <v-text-field-->
                <!--                                        mask="#########"-->
                <!--                                        type="tel"-->
                <!--                                        prepend-icon="fal fa-mobile-alt"-->
                <!--                                        name="username"-->
                <!--                                        v-bind:label="$t('phone_number')"-->
                <!--                                        v-model="username"-->
                <!--                                        :rules="usernameRules"-->
                <!--                                        required-->
                <!--                                ></v-text-field>-->
                <!--TODO parametrizar dark=false na ola,wow food
                dark
                -->
                <VuePhoneNumberInput :dark="dark_theme" v-model="username"
                                     :default-country-code="countryCode"
                                     :preferred-countries="preferredCountryCodes"
                                     required
                                     :error="valid==false"
                                     :translations="{
                                                      countrySelectorLabel: this.$vuetify.t('$vuetify.help_country_code'),
                                                      phoneNumberLabel: this.$vuetify.t('$vuetify.help_mobile_number'),
                                                      example: this.$vuetify.t('$vuetify.help_example')}"
                                     @update="define_selected_country_code"
                />
              </v-flex>

              <v-spacer class="my-2"></v-spacer>

              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                      :disabled="!valid"
                      @click="submit"
                      color="primary"
                      large
                  >
                    {{ $vuetify.t('$vuetify.next') }}
                    <v-icon right small>fal fa-angle-double-right</v-icon>
                  </v-btn>
                </div>
              </v-flex>
              <!-- @modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions-->
              <v-spacer class="my-3"></v-spacer>
              <v-flex xs12>
                <div class="text-xs-center">
                  <p class="subheading font-weight-regular" @click="goToTermsPolicy"><a
                      style="color: inherit;">{{ $vuetify.t('$vuetify.gdpr_agreement.terms_policy') }}</a></p>
                </div>
              </v-flex>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex';
import {userService} from '../../_services'
import {getErrorMessage, recaptchaHelper} from "../../_helpers";
import FBLoginButton from '../../components/sociallogin/FBLoginButton.vue';
import IGLoginButton from '../../components/sociallogin/IGLoginButton.vue';
import GOOGLELoginButton from '../../components/sociallogin/GOOGLELoginButton.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
//TODO mover isto para block css
import "clientEntryLayout"

export default {
  data() {
    return {
      dark_theme: true,
      username: '',
      valid: false,
      selected_country_code: null,

      img_folder: "",
      // @modified ana.castro 2019.10.28 Sometimes the Social Provider definitions were not available to be used on the mounted() section of the LogInUser
      // loginProviderFacebook: false,
      // loginProviderInstagram: false,
      // loginProviderGoogle: false
      // fbSignInParams: {
      //     scope: 'email',
      //     return_scopes: true
      // }
    }
  },
  components: {FBLoginButton, IGLoginButton, GOOGLELoginButton, VuePhoneNumberInput},
  computed: {
    // Defining the Username field as being mandatory;
    usernameRules: function () {
      let re = /^9[0-9]{8}$/;
      return [
        v => !!v || this.$vuetify.t('$vuetify.phone_number'),
        v => (v && v.length === 9) || this.$vuetify.t('$vuetify.authentication.username_nine_digits'),
        v => (v && re.test(v)) || this.$vuetify.t('$vuetify.authentication.phone_number_invalid')
      ]
    },
    // @modified ana.castro 2019.10.28 Sometimes the Social Provider definitions were not available to be used on the mounted() section of the LogInUser
    ...mapGetters({
      loginProviderFacebook: 'configs/loginProviderFacebook',
      loginProviderInstagram: 'configs/loginProviderInstagram',
      loginProviderGoogle: 'configs/loginProviderGoogle',
      // @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
      countryCode: 'configs/countryCode',
      preferredCountryCodes: 'configs/preferredCountryCodes',
    })

  },
  created() {
    this.$store.dispatch('authentication/logout');
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.username) {

        // 1 - setting the Loading Layer
        this.$store.dispatch("loader/setLoading", true);

        // 2 -
        // @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
        let obj = {
          "username": this.selected_country_code + '-' + this.username.split(' ').join('')
        };

        // The "this" loses its value when used inside the Promise of the verifyUser.
        //  therefore its value is stored in a variable and used later on a successful result if the userService.verifyUser request
        let local_this = this;

        // 3 - using the verifyUser function of the userService;
        //  this service receives a username and checks whether or not the username is already registered both as a USER and a CUSTOMER.
        //  this verification is made using the API method verify_if_user_exists.
        //  Receiving a successful response:
        //  3.1 - the username is stored (on the store) using the authentication module function setLoginUsername
        //  3.2 - the user is redirected to the following interface:
        //      3.2.1 if it is not a new user -> redirect to the Password Interface
        //      3.2.2 if it is a new user -> redirect to the Profile interface
        //          only after filling in the profile information, the user will be asked to insert the password received by sms
        recaptchaHelper('verifyUser', this).then((token) => {
              obj.recaptcha_token = token;
              userService.verifyUser(obj).then(result => {
                    this.$log.debug("Verify User | Received User Status = " + result.status);

                    local_this.$store.dispatch('authentication/setLoginUsername', result.username);

                    if (result.info_user === 'newUser') {
                      local_this.$router.push({
                        name: 'user-register',

                      });
                    } else if (result.info_user === 'existingUser') {
                      local_this.$router.push({name: 'login-auth', params: {status: result.status}});
                    }

                    local_this.$store.dispatch("loader/setLoading", false);
                  },
                  error => {
                    getErrorMessage(error, 'Verify User', this);
                  });
            },
            error => {
              getErrorMessage(error, 'Verify User Recaptcha', this);
            });
      }
    },
    //@modified ana.castro 2019.12.03 The Login interface must display a link to access the Terms and Conditions
    goToTermsPolicy() {
      this.$router.push({name: "terms-policy"});
    },
    // onSocialSignInError(error) {
    //     this.$log.debug("Social Sign In Error | User cancelled login or did not fully authorize", error);
    // }

    // @modified ana.castro 2020.05.12 SCLAPP-28 The Country Code should be appended to the Phone Number
    /**
     *
     * @param payload
     */
    define_selected_country_code(payload) {
      //Payload Example
      // {
      // 	"countryCode": "FR",
      // 	"isValid": true,
      // 	"phoneNumber": "0665656565",
      // 	"countryCallingCode": "33",
      // 	"formattedNumber": "+33665656565",
      // 	"nationalNumber": "665656565",
      // 	"formatInternational": "+33 6 65 65 65 65",
      // 	"formatNational": "06 65 65 65 65",
      // 	"uri": "tel:+33665656565",
      // 	"e164": "+33665656565"
      // }
      this.selected_country_code = payload.countryCallingCode;
      // modified @daniel.silva 2020.07.05 onl
      this.valid = payload.isValid
    }
  },
  mounted() {
    this.img_folder = process.env.VUE_APP_ASSETS_FOLDER;
    this.dark_theme = process.env.VUE_APP_VUETIFY_DARK_THEME === "True";
    // Called after the instance has been mounted:
    // @modified ana.castro 2019.10.28 Sometimes the Social Provider definitions were not available to be used on the mounted() section of the LogInUser
    // this.loginProviderFacebook = this.$store.state.configs.loginProviderFacebook;
    // this.loginProviderInstagram = this.$store.state.configs.loginProviderInstagram;
    // this.loginProviderGoogle = this.$store.state.configs.loginProviderGoogle;
  },
}
</script>

<style lang="stylus">
/*.application*/
/*  background: #15191c url(../../assets/background.jpg) repeat-y 0 0 !important*/

/****************************************** START WOWFOODS ***********************************************************/

/****************************************** END WOWFOODS *************************************************************/

/****************************************** START CACULA/DEGEMA *************************************************************/
/*#login-user-ui
    .v-responsive.v-image.my-5
        height: 300px !important;
*/
/****************************************** END CACULA/DEGEMA *************************************************************/

/****************************************** START NAZ *************************************************************/
/*
#login-user-ui
  background: #EC0501 !important

  .login-logo
    margin-top: 10px !important;
    margin-bottom: 20px !important;

  .theme--dark.v-label
    color: #FFFFFF !important

  .theme--dark.v-input:not(.v-input--is-disabled) input
    color: #fff !important
    caret-color: #fff !important

  .error--text
    color: #fd0 !important
    caret-color: #fd0 !important

  .theme--dark.v-icon.error--text
    color: #fd0 !important

  .theme--dark.v-icon
    color: #FFFFFF !important

  .v-text-field > .v-input__control > .v-input__slot:after,
  .v-text-field > .v-input__control > .v-input__slot:after
    border-color: #fff !important

  .v-responsive.v-image.my-5
    height: 300px !important

  .theme--dark.v-text-field > .v-input__control > .v-input__slot::before
    border-color: #fff !important

  .fa-angle-double-right::before
    content: "\f105"

  .login-title2,
  .login-user-spacer,
  .login-title2-spacer
    display: none

  .login-title1 h2
    font-size: 16px
    color: #ffffff

  .v-btn.primary
    background-color: #fff !important

  .v-btn.primary .v-btn__content,
  .v-btn.primary .v-icon
    color: #EC0501 !important

  // FONT SIZES CONFIG

  .v-btn
    font-size: 18px !important;

  .v-input,
  .v-label
    font-size 18px

  .input-tel__input
    color: black
*/

/******************************************** END NAZ *************************************************************/

</style>
